import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

const authGuards = [MsalGuard];

export const routes: Routes = [
  { path: '', redirectTo: '/assignments', pathMatch: 'full' },
  {
    path: 'assignments',
    loadComponent: () =>
      import('./components/search/search.component').then((m) => m.SearchComponent),
    canActivate: authGuards,
  },
  {
    path: 'assignments/detail/:compositeId',
    loadComponent: () =>
      import('./components/assignment-detail/assignment-detail.component').then(
        (m) => m.AssignmentDetailComponent,
      ),
    canActivate: authGuards,
  },
  {
    path: 'claim-overview/:claimNumber/:seq',
    loadComponent: () =>
      import('./components/claim-overview/claim-overview.component').then(
        (m) => m.ClaimOverviewComponent,
      ),
    canActivate: authGuards,
  },
  {
    path: 'policy/:claimNumber/:seq',
    loadComponent: () =>
      import('./components/policy/policy.component').then((m) => m.PolicyComponent),
    canActivate: authGuards,
  },
  {
    path: 'loss/:claimNumber/:seq',
    loadComponent: () => import('./components/loss/loss.component').then((m) => m.LossComponent),
    canActivate: authGuards,
  },
  {
    path: 'parties/:claimNumber/:seq',
    loadComponent: () =>
      import('./components/parties/parties.component').then((m) => m.PartiesComponent),
    canActivate: authGuards,
  },
  {
    path: 'units/:claimNumber/:seq',
    loadComponent: () => import('./components/units/units.component').then((m) => m.UnitsComponent),
    canActivate: authGuards,
  },
  {
    path: 'notes/:claimNumber/:seq',
    loadComponent: () => import('./components/notes/notes.component').then((m) => m.NotesComponent),
    canActivate: authGuards,
  },
  {
    path: 'stop-storage-letters/:compositeId',
    loadComponent: () =>
      import('./components/stop-storage-letters/stop-storage-letters.component').then(
        (m) => m.StopStorageLettersComponent,
      ),
    canActivate: authGuards,
  },
  {
    path: 'activity-log/:claimNumber/:seq',
    loadComponent: () =>
      import('./components/activity-log/activity-log.component').then(
        (m) => m.ActivityLogComponent,
      ),
    canActivate: authGuards,
  },
  { path: '**', redirectTo: '/assignments' },
];
